import React, { useState, useEffect } from "react";
import styled from "styled-components";
import {
  FaUsers,
  FaComments,
  FaRocket,
  FaStar,
  FaTimes,
  FaArrowRight,
  FaChevronLeft,
  FaChevronRight,
  FaChevronDown,
} from "react-icons/fa";
import colors from "../colors";

const InfoContainer = styled.div`
  color: #fff;
  background: ${colors.darkPurple};
  padding: 30px 0 0 0;

  @media screen and (max-width: 768px) {
    padding: 70px 0;
  }
`;

const InfoWrapper = styled.div`
  display: flex;
  z-index: 1;
  height: 100%;
  width: 100%;
  max-width: 1100px;
  margin-right: auto;
  margin-left: auto;
  padding: 0 24px;
  justify-content: center;
`;

const InfoRow = styled.div`
  display: flex;
  align-items: center;
  flex-direction: ${({ imgStart }) => (imgStart ? "row-reverse" : "row")};

  @media screen and (max-width: 768px) {
    flex-direction: column;
  }
`;

const Column1 = styled.div`
  margin-bottom: 0px;
  padding: 0 15px;
  grid-area: col1;
`;

const Column2 = styled.div`
  margin-bottom: 15px;
  padding: 0 15px;
  grid-area: col2;
`;

const TextWrapper = styled.div`
  max-width: 850px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-top: 0;
  padding-bottom: 60px;

  @media screen and (max-width: 768px) {
    padding-bottom: 30px;
    text-align: center;
  }
`;

const TopLine = styled.p`
  color: ${colors.skyBlue};
  font-size: 16px;
  line-height: 16px;
  font-weight: 700;
  letter-spacing: 1.4px;
  text-transform: uppercase;
  margin-bottom: 16px;
`;

const Heading = styled.h1`
  margin-bottom: 24px;
  font-size: 48px;
  line-height: 1.1;
  font-weight: 600;
  color: #fff;

  span {
    background: ${colors.gradientPrimary};
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  @media screen and (max-width: 768px) {
    font-size: 32px;
  }
`;

const Subtitle = styled.p`
  max-width: 850px;
  margin-bottom: 35px;
  font-size: 18px;
  line-height: 24px;
  color: #fff;
`;

const BtnWrap = styled.div`
  display: flex;
  justify-content: flex-start;

  @media screen and (max-width: 768px) {
    justify-content: center;
  }
`;

const Button = styled.a`
  border-radius: 50px;
  background: ${colors.gradientButton};
  white-space: nowrap;
  padding: 12px 30px;
  color: #fff;
  font-size: 16px;
  outline: none;
  border: none;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all 0.2s ease-in-out;
  text-decoration: none;

  &:hover {
    transition: all 0.2s ease-in-out;
    background: #fff;
    color: ${colors.purple};
  }
`;

const ImgWrap = styled.div`
  max-width: 555px;
  height: 100%;
`;

const IconContainer = styled.div`
  width: 100%;
  height: 400px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: ${colors.gradientPrimary};
  border-radius: 10px;
  font-size: 80px;
  color: rgba(255, 255, 255, 0.8);
  position: relative;
  gap: 30px;
  padding: 0 40px;
`;

const IconWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 60px;
  color: rgba(255, 255, 255, 0.8);
  background: rgba(255, 255, 255, 0.1);
  width: 100px;
  height: 100px;
  border-radius: 50%;
  margin-bottom: 10px;
  transition: all 0.3s ease-in-out;

  &:hover {
    transform: scale(1.05);
    background: rgba(255, 255, 255, 0.15);
  }

  @media screen and (max-width: 768px) {
    width: 80px;
    height: 80px;
    font-size: 50px;
  }
`;

const TestimonialButton = styled.button`
  border-radius: 50px;
  background: rgba(255, 255, 255, 0.2);
  white-space: nowrap;
  padding: 12px 30px;
  color: #fff;
  font-size: 16px;
  outline: none;
  border: 1px solid rgba(255, 255, 255, 0.4);
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all 0.2s ease-in-out;
  backdrop-filter: blur(5px);
  gap: 10px;
  width: 80%;
  max-width: 300px;

  &:hover {
    background: rgba(255, 255, 255, 0.3);
    transform: scale(1.05);
  }

  svg {
    font-size: 14px;
    transition: transform 0.2s ease-in-out;
  }

  &:hover svg {
    transform: translateX(3px);
  }
`;

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  backdrop-filter: blur(5px);
`;

const ModalContent = styled.div`
  background: ${colors.darkPurple};
  padding: 20px;
  border-radius: 20px;
  max-width: 800px;
  width: 90%;
  max-height: 90vh;
  overflow: hidden;
  position: relative;
  box-shadow: 0 0 30px rgba(0, 0, 0, 0.3);
  display: flex;
  flex-direction: column;
`;

const CloseButton = styled.button`
  position: absolute;
  top: 20px;
  right: 20px;
  background: none;
  border: none;
  color: #fff;
  font-size: 24px;
  cursor: pointer;
  padding: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease-in-out;

  &:hover {
    transform: scale(1.1);
    color: ${colors.skyBlue};
  }
`;

const TestimonialTitle = styled.h2`
  font-size: 2rem;
  margin-bottom: 15px;
  text-align: center;
  color: #fff;
  background: ${colors.gradientPrimary};
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  padding: 0 20px;

  @media screen and (max-width: 768px) {
    font-size: 1.5rem;
    margin-bottom: 10px;
  }
`;

const ScrollContainer = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 10px 20px;
  scroll-behavior: smooth;

  /* Customize scrollbar */
  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: rgba(255, 255, 255, 0.1);
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.3);
    border-radius: 4px;

    &:hover {
      background: rgba(255, 255, 255, 0.4);
    }
  }
`;

const ConversationCard = styled.div`
  width: 100%;
  padding: 10px 0;
  margin-bottom: 20px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 10px;
  transition: all 0.3s ease-in-out;
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;

  &:last-child {
    margin-bottom: 0;
  }
`;

const ConversationImage = styled.img`
  width: 100%;
  height: auto;
  max-height: 70vh;
  object-fit: contain;
  border-radius: 10px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
  transition: transform 0.3s ease-in-out;
  display: block;
  margin: 0 auto;

  @media screen and (max-width: 768px) {
    max-height: 60vh;
  }
`;

const Message = styled.div`
  background: ${(props) =>
    props.isUser ? "rgba(255, 255, 255, 0.15)" : colors.gradientPrimary};
  padding: 15px;
  border-radius: 15px;
  margin-bottom: 15px;
  max-width: 80%;
  ${(props) => (props.isUser ? "margin-left: auto;" : "margin-right: auto;")}
  color: #fff;
  font-size: 16px;
  line-height: 1.5;

  @media screen and (max-width: 768px) {
    font-size: 14px;
    padding: 12px;
    max-width: 90%;
  }
`;

const ClientsSection = styled.section`
  padding: 60px 0;
  background: #f9f9f9;
`;

const ClientsContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
  text-align: center;
`;

const ClientsTitle = styled.h2`
  font-size: 2rem;
  margin-bottom: 40px;
  color: ${colors.darkGray};
`;

const ClientsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 30px;
  align-items: center;
  justify-items: center;
  margin-top: 40px;
`;

const ClientLogo = styled.div`
  width: 120px;
  height: 80px;
  background-color: #e0e0e0;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  color: #666;
`;

const CasesSection = styled.div`
  color: #fff;
  background: ${colors.darkPurple};
  padding: 40px 0;

  @media screen and (max-width: 768px) {
    padding: 70px 0;
  }

  .carousel {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 40px;
    position: relative;
  }

  .carousel-inner {
    overflow: hidden;
  }

  .carousel-item {
    display: none;
    transition: transform 1.5s ease-in-out;
  }

  .carousel-item.active {
    display: block;
  }

  .carousel-control-prev,
  .carousel-control-next {
    width: 50px;
    height: 50px;
    background: ${colors.gradientButton};
    border-radius: 50%;
    opacity: 0.9;
    top: 50%;
    transform: translateY(-50%);
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
  }

  .carousel-control-prev {
    left: 10px;
  }

  .carousel-control-next {
    right: 10px;
  }

  .carousel-control-prev:hover,
  .carousel-control-next:hover {
    opacity: 1;
    transform: translateY(-50%) scale(1.1);
  }

  .carousel-control-prev-icon,
  .carousel-control-next-icon {
    width: 25px;
    height: 25px;
    filter: brightness(100);
  }

  @media screen and (max-width: 768px) {
    .carousel {
      padding: 0 30px;
    }

    .carousel-control-prev,
    .carousel-control-next {
      width: 40px;
      height: 40px;
      background: ${colors.gradientButton};
    }

    .carousel-control-prev {
      left: 5px;
    }

    .carousel-control-next {
      right: 5px;
    }

    .carousel-control-prev-icon,
    .carousel-control-next-icon {
      width: 20px;
      height: 20px;
    }
  }

  .images-container {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 30px;
    padding: 0 20px;
  }

  .case-image {
    width: 100%;
    height: 500px;
    object-fit: contain;
    border-radius: 10px;
    background: rgba(255, 255, 255, 0.05);
    padding: 10px;
  }

  @media screen and (max-width: 768px) {
    .images-container {
      grid-template-columns: 1fr;
      gap: 15px;
    }

    .case-image {
      height: 400px;
      max-width: 350px;
      margin: 0 auto;
    }
  }
`;

const CasesTitle = styled.h2`
  text-align: center;
  font-size: 48px;
  margin-bottom: 50px;
  color: #fff;

  span {
    background: ${colors.gradientPrimary};
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  @media screen and (max-width: 768px) {
    font-size: 32px;
  }
`;

const ShowMoreButton = styled.button`
  margin: 40px auto 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 15px 30px;
  background: ${colors.gradientButton};
  border: none;
  border-radius: 50px;
  color: white;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.3s ease;
  gap: 10px;

  &:hover {
    transform: scale(1.05);
  }
`;

const CarouselContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
`;

const InfoSection = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [visibleCarousels, setVisibleCarousels] = useState(1);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const conversations = [
    { id: 1, image: "assets/images/conversa_1/1.webp" },
    { id: 2, image: "assets/images/conversa_1/2.webp" },
    { id: 3, image: "assets/images/conversa_1/3.webp" },
    { id: 4, image: "assets/images/conversa_1/4.webp" },
    { id: 5, image: "assets/images/conversa_1/5.webp" },
    { id: 6, image: "assets/images/conversa_1/6.webp" },
  ];

  const conversations2 = [
    { id: 7, image: "assets/images/conversa_2/Lala_1.jpeg" },
    { id: 8, image: "assets/images/conversa_2/Lala_2.jpeg" },
    { id: 9, image: "assets/images/conversa_2/Lala_3.jpeg" },
    { id: 10, image: "assets/images/conversa_2/Lala_4.jpeg" },
    { id: 11, image: "assets/images/conversa_2/Lala_5.jpeg" },
    { id: 12, image: "assets/images/conversa_2/Lala_6.jpeg" },
  ];

  const conversations3 = [
    { id: 13, image: "assets/images/conversa_3/Mayara_1.jpeg" },
    { id: 14, image: "assets/images/conversa_3/Mayara_2.jpeg" },
    { id: 15, image: "assets/images/conversa_3/Mayara_3.jpeg" },
    { id: 16, image: "assets/images/conversa_3/Mayara_4.jpeg" },
    { id: 17, image: "assets/images/conversa_3/Mayara_5.jpeg" },
    { id: 18, image: "assets/images/conversa_3/Mayara_6.jpeg" },
    { id: 19, image: "assets/images/conversa_3/Mayara_7.jpeg" },
  ];

  const handleShowMore = () => {
    if (visibleCarousels === 3) {
      setVisibleCarousels(1);
    } else {
      setVisibleCarousels(prev => prev + 1);
    }
  };

  const getButtonText = () => {
    if (visibleCarousels === 3) {
      return 'Ver menos resultados';
    }
    return 'Ver mais resultados';
  };

  const groupConversations = (conversations) => {
    if (isMobile) {
      return conversations.map(conv => [conv]);
    }
    
    const groups = [];
    for (let i = 0; i < conversations.length; i += 3) {
      groups.push(conversations.slice(i, Math.min(i + 3, conversations.length)));
    }
    return groups;
  };

  const groupedConversations = groupConversations(conversations);
  const groupedConversations2 = groupConversations(conversations2);
  const groupedConversations3 = groupConversations(conversations3);

  const CarouselComponent = ({ conversations, id }) => (
    <div 
      id={`casesCarousel${id}`} 
      className="carousel slide" 
      data-bs-ride="carousel"
      data-bs-interval="8000"
      data-bs-pause="hover"
    >
      <div className="carousel-inner">
        {conversations.map((group, index) => (
          <div
            key={index}
            className={`carousel-item ${index === 0 ? "active" : ""}`}
          >
            <div className="images-container">
              {group.map((item) => (
                item.image ? (
                  <img
                    key={item.id}
                    src={item.image}
                    alt={`Case ${item.id}`}
                    className="case-image"
                    loading="lazy"
                  />
                ) : (
                  <div key={item.id} className="case-image" />
                )
              ))}
            </div>
          </div>
        ))}
      </div>
      <button 
        className="carousel-control-prev" 
        type="button" 
        data-bs-target={`#casesCarousel${id}`}
        data-bs-slide="prev"
      >
        <span
          className="carousel-control-prev-icon"
          aria-hidden="true"
        ></span>
        <span className="visually-hidden">Anterior</span>
      </button>
      <button 
        className="carousel-control-next" 
        type="button" 
        data-bs-target={`#casesCarousel${id}`}
        data-bs-slide="next"
      >
        <span
          className="carousel-control-next-icon"
          aria-hidden="true"
        ></span>
        <span className="visually-hidden">Próximo</span>
      </button>
    </div>
  );

  return (
    <>
      <InfoContainer id="info">
        <InfoWrapper>
          <InfoRow imgStart={false}>
            <Column1>
              <TextWrapper>
                <TopLine>Funcionários de IA</TopLine>
                <Heading>
                  <span>Automatize</span> suas vendas com a eficiência de um
                  time de elite
                </Heading>
                <Subtitle>
                  Nossos Funcionários de IA são incansáveis, precisos e
                  altamente inteligentes. Eles analisam, negociam e fecham
                  vendas em todos os canais — sem pausas e sem cansaço.
                  Impulsionando seus resultados como um time de alta
                  performance.
                </Subtitle>
                <BtnWrap>
                  <Button href="/#planos">Ver planos</Button>
                </BtnWrap>
              </TextWrapper>
            </Column1>
            {/* <Column2>
              <ImgWrap>
                <IconContainer>
                  <IconWrapper>
                    <FaComments />
                  </IconWrapper>
                  <TestimonialButton onClick={() => setIsModalOpen(true)}>
                    Veja Funcionamento <FaArrowRight />
                  </TestimonialButton>
                </IconContainer>
              </ImgWrap>
            </Column2> */}
          </InfoRow>
        </InfoWrapper>
      </InfoContainer>

      <CasesSection id="cases">
        <CasesTitle>
          <span>Resultados</span> que entregamos!
        </CasesTitle>
        
        <CarouselContainer>
          <CarouselComponent conversations={groupedConversations} id="1" />

          {visibleCarousels >= 2 && (
            <CarouselComponent conversations={groupedConversations2} id="2" />
          )}

          {visibleCarousels >= 3 && (
            <CarouselComponent conversations={groupedConversations3} id="3" />
          )}

          <ShowMoreButton onClick={handleShowMore}>
            {getButtonText()} 
            <FaChevronDown style={{ 
              transform: visibleCarousels === 3 ? 'rotate(180deg)' : 'rotate(0)', 
              transition: 'transform 0.3s ease' 
            }}/>
          </ShowMoreButton>
        </CarouselContainer>
      </CasesSection>

      {isModalOpen && (
        <ModalOverlay onClick={() => setIsModalOpen(false)}>
          <ModalContent onClick={(e) => e.stopPropagation()}>
            <CloseButton onClick={() => setIsModalOpen(false)}>
              <FaTimes />
            </CloseButton>
            <TestimonialTitle>Ao Vivo!</TestimonialTitle>
            <ScrollContainer>
              {conversations.map((conversation) => (
                <ConversationCard key={conversation.id}>
                  <ConversationImage
                    src={conversation.image}
                    alt={`Conversa de exemplo ${conversation.id}`}
                    loading="lazy"
                  />
                </ConversationCard>
              ))}
            </ScrollContainer>
          </ModalContent>
        </ModalOverlay>
      )}

      {/* <ClientsSection id="clients">
        <ClientsContainer>
          <ClientsTitle>Com a confiança de líderes do mercado</ClientsTitle>
          <ClientsGrid>
            <ClientLogo>Logo Cliente 1</ClientLogo>
            <ClientLogo>Logo Cliente 2</ClientLogo>
            <ClientLogo>Logo Cliente 3</ClientLogo>
            <ClientLogo>Logo Cliente 4</ClientLogo>
            <ClientLogo>Logo Cliente 5</ClientLogo>
            <ClientLogo>Logo Cliente 6</ClientLogo>
          </ClientsGrid>
        </ClientsContainer>
      </ClientsSection> */}
    </>
  );
};

export default InfoSection;
